<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144132' | translate }}</h2>
  <app-smart-search-form [formPath]="formPath" [searchByList]="searchByList$ | async" [onSearch]="onSearch" [searching$]="searching$" [formClearOnDestroy]="true"></app-smart-search-form>

  <app-message-data [errorMsg$]="errorMessage$"></app-message-data>

  <div mat-dialog-content>
    <app-data-grid [isServerSidePagingFiltering]="true" [onLoadServerSideData]="onGetData" [totalCountForServerSidePagingFiltering$]="totalCount$" [isLoading]="searching$ | async"
      [dataSource$]="dataSource$" [columnsDef]="dataGridColumnDef" [enableRowSelect]="false"></app-data-grid>
  </div>

  <div mat-dialog-actions class="row mt-2 p-2 justify-content-end">
    <div class="col-auto align-self-end">
      <button class="button--default  me-3" (click)="onExport()">{{ 'ml_151408' | translate}}</button>
      <button class="button--default" [mat-dialog-close]="true">{{ 'ml_143929' | translate}}</button>
    </div>
  </div>
</div>
